import { Container, rem, Text, useMantineTheme } from '@mantine/core';

export const ErrorPage400 = () => {
  const theme = useMantineTheme();

  return (
    <Container style={{ paddingTop: rem(80), paddingBottom: rem(80) }}>
      <Text
        c={theme.colors.dark[6]}
        fw={600}
        size="lg"
        style={{
          textAlign: 'center',
          maxWidth: rem(500),
          margin: 'auto',
        }}
      >
        Form not found or has already been completed.
      </Text>
      <Text
        c={theme.colors.dark[6]}
        size="md"
        style={{
          textAlign: 'center',
          maxWidth: rem(500),
          margin: 'auto',
          marginTop: rem(16),
        }}
      >
        Please check the link or contact your hospital if you believe this is an error.
      </Text>
    </Container>
  );
};
